import { render, staticRenderFns } from "./estate-item.vue?vue&type=template&id=c3f05d34&scoped=true&"
import script from "./estate-item.vue?vue&type=script&lang=js&"
export * from "./estate-item.vue?vue&type=script&lang=js&"
import style0 from "./estate-item.vue?vue&type=style&index=0&id=c3f05d34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f05d34",
  null
  
)

export default component.exports